var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from "axios";
import { join } from "path";
import queryString from "query-string";
import { getLogger } from "../../logger";
import { cachedAxios } from "./axiosClient";
var _a = getLogger("service:addressresolver"), trace = _a.trace, error = _a.error;
// Returns an url with no trailing slash
export var getPath = function (path, base) { return new URL(path, base).href; };
var get = function (_a) {
    var url = _a.url, apiHeader = _a.apiHeader, apiKey = _a.apiKey, _b = _a.cache, cache = _b === void 0 ? false : _b;
    return __awaiter(void 0, void 0, void 0, function () {
        var client, headers;
        return __generator(this, function (_c) {
            client = cache ? cachedAxios : axios;
            if (apiHeader && apiKey) {
                headers = {};
                headers[apiHeader] = apiKey;
                return [2 /*return*/, client.get(url, { headers: headers })];
            }
            else {
                return [2 /*return*/, client.get(url)];
            }
            return [2 /*return*/];
        });
    });
};
export var entityLookup = function (_a) {
    var limit = _a.limit, offset = _a.offset, query = _a.query, endpoint = _a.endpoint, apiHeader = _a.apiHeader, apiKey = _a.apiKey, path = _a.path;
    return __awaiter(void 0, void 0, void 0, function () {
        var url, response;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    url = queryString.stringifyUrl({
                        url: getPath(path, endpoint),
                        query: {
                            q: query,
                            limit: limit,
                            offset: offset,
                        },
                    });
                    return [4 /*yield*/, get({ url: url, apiHeader: apiHeader, apiKey: apiKey })];
                case 1:
                    response = _b.sent();
                    return [2 /*return*/, response.data];
            }
        });
    });
};
export var resolveAddressIdentityByEndpoint = function (url, apiHeader, apiKey) { return __awaiter(void 0, void 0, void 0, function () {
    var response, e_1;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4 /*yield*/, get({
                        url: url,
                        apiHeader: apiHeader,
                        apiKey: apiKey,
                        cache: true,
                    })];
            case 1:
                response = _b.sent();
                return [2 /*return*/, (_a = response.data) === null || _a === void 0 ? void 0 : _a.identity];
            case 2:
                e_1 = _b.sent();
                trace("Resolve Address Status: " + e_1);
                return [2 /*return*/, undefined];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var getIdentity = function (addresses, address) { return __awaiter(void 0, void 0, void 0, function () {
    var identity;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, addresses.reduce(function (accumulator, currentValue) { return __awaiter(void 0, void 0, void 0, function () {
                    var url, identity;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, accumulator];
                            case 1:
                                if (_a.sent())
                                    return [2 /*return*/, accumulator];
                                if (!currentValue.path.addressResolution)
                                    return [2 /*return*/, undefined];
                                url = getPath(join(currentValue.path.addressResolution, address), currentValue.endpoint);
                                return [4 /*yield*/, resolveAddressIdentityByEndpoint(url, currentValue.apiHeader, currentValue.apiKey)];
                            case 2:
                                identity = _a.sent();
                                if (!identity)
                                    return [2 /*return*/, undefined];
                                return [2 /*return*/, { name: identity.name, resolvedBy: currentValue.name, source: identity.source }];
                        }
                    });
                }); }, Promise.resolve(undefined))];
            case 1:
                identity = _a.sent();
                return [2 /*return*/, identity];
        }
    });
}); };
export var getFeatures = function (url, apiHeader, apiKey) { return __awaiter(void 0, void 0, void 0, function () {
    var response, e_2, err;
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _d.trys.push([0, 2, , 3]);
                return [4 /*yield*/, get({
                        url: url,
                        apiHeader: apiHeader,
                        apiKey: apiKey,
                        cache: false,
                    })];
            case 1:
                response = _d.sent();
                return [2 /*return*/, response.data];
            case 2:
                e_2 = _d.sent();
                err = e_2;
                if ((_a = err.response) === null || _a === void 0 ? void 0 : _a.data) {
                    error(err.response.data);
                }
                throw new Error(((_c = (_b = err.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) || err.message);
            case 3: return [2 /*return*/];
        }
    });
}); };
//# sourceMappingURL=index.js.map